import { Disclosure } from "@headlessui/react";
import { FAQSectionTitle } from "./components/faq-section-title";
import { FAQButton } from "./components/faq-button";
import { FAQItem } from "./components/faq-item";
import { Text } from "../../components/text";

export const FAQHowToSell = () => {
  return (
    <>
      <FAQSectionTitle>
        Cara Berjualan dengan Aplikasi Jooalan
      </FAQSectionTitle>

      <Disclosure>
        <FAQButton>
          Bagaimana cara saya berjualan dengan produk-produk Jooalan sebagai Reseller?
        </FAQButton>
        <FAQItem>
          <Text>
            Sebagai reseller, Anda cukup melakukan stok barang dengan produk-produk Jooalan kemudian melakukan pemesanan di aplikasi Jooalan. Kemudian barang yang sudah sampai ke toko Anda, dapat dijual kembali kepada customer Anda, baik itu melalui sosial media, marketplace online maupun secara offline dengan potensi harga jual lebih dari 50% dari barang yang Anda beli lewat aplikasi Jooalan.
          </Text>
        </FAQItem>
      </Disclosure>
      <Disclosure>
        <FAQButton>
          Bagaimana cara saya berjualan dengan produk-produk Jooalan sebagai Dropshipper?
        </FAQButton>
        <FAQItem>
          <Text>
            Anda hanya perlu men-share atau mempromosikan produk-produk di katalog aplikasi Jooalan melalui sosial media yang Anda punya melalui ikon share pada produk. Jika ada transaksi dari customer, Anda dapat bantu proses pemesanannya melalui aplikasi Jooalan dengan tipe pembelian <b>Dropship</b>
          </Text>
        </FAQItem>
      </Disclosure>
    </>
  )
}